import { render, staticRenderFns } from "./MasterCompanyInstructionPerModule.vue?vue&type=template&id=b46a2f0c&scoped=true&"
import script from "./MasterCompanyInstructionPerModule.vue?vue&type=script&lang=js&"
export * from "./MasterCompanyInstructionPerModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46a2f0c",
  null
  
)

export default component.exports